export default {
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Number Square',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Number Square',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Number Square Level 1',
      invalid: 'Name is required',
    },
    showAnswer: {
      label: 'Show answer',
    },
    colored: {
      label: 'Colored',
    },
    maxValue: {
      label: 'Available numbers:',
      option9: '1 to 9',
      option16: '1 to 16',
      option25: '1 to 25',
    },
    difficulty: {
      label: 'Difficulty:',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      random: 'Random',
    },
    distribution: {
      checkboxLabel: 'Distribute by percentage',
      tooltipText:
        'Math operators will be distributed in the game according to the percentages set below.',
    },
    operators: {
      plus: 'Addition (+)',
      minus: 'Subtraction (−)',
      times: 'Multiplication (×)',
      divide: 'Division (÷)',
    },
  },
  button: {
    generate: 'Generate game',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'numberSquare',
  },
  alert: {
    generated: 'Puzzle generated successfully!',
    generateFailed: 'Could not generate the puzzle.',
    workerError: 'Internal error during generation.',
    gameSaved: 'Game saved successfully!',
    workerErrors: {
      noCombinations:
        'Could not generate combinations with these operators. Please try again.',
    },
  },
};
